import { formatearImporte } from '../../../nucleo/importes/formatoDeImporte.js';

/**
 * «CÓMO SALE ESTA CIFRA» — desglose del PAGO ESPERADO DEL PERIODO
 * (incremento 18/21, RF-252, prototipo v39: panel y detalle del vencimiento).
 *
 * PIEZA COMPARTIDA: la usan el renglón del panel y el detalle del vencimiento, para
 * que las dos pantallas no puedan enseñar desgloses distintos de la misma cifra.
 *
 * LAS CUATRO CIFRAS LLEGAN YA CALCULADAS DEL SERVIDOR y aquí NO SE SUMA NI SE RESTA
 * NADA (RNF-059, RNF-130, RF-252). El signo menos de las dos cifras de compras a
 * meses es ETIQUETA, no aritmética: se escribe delante del importe formateado,
 * exactamente como el prototipo lo dibuja; el importe que viaja es positivo.
 *
 * POR QUÉ EXISTE ESTE BLOQUE: la cifra protagonista del renglón ya no es la deuda al
 * corte, y sin el desglose nadie podría ver de dónde sale. Además es lo que le
 * permite a la titular vigilar su diferido declarado hasta que el incremento 19 lo
 * respalde con planes.
 */
export function DesgloseDelPagoEsperado({ tarjeta, enPasado = false, datoDePrueba = 'desglose-del-pago-esperado' }) {
  if (!tarjeta?.importePagoEsperado) return null;

  const iso = tarjeta.codigoISO;

  return (
    <div className="msi" data-prueba={datoDePrueba}>
      <div className="msi-t">Cómo sale esta cifra</div>

      <div className="fila">
        <span className="crece">Deuda acumulada al corte</span>
        <b data-prueba="desglose-saldo-al-corte">
          {formatearImporte(tarjeta.importeSaldoAlCorte, iso)}
        </b>
      </div>
      <div className="fila">
        <span className="crece">Compras a meses que declaraste</span>
        <b data-prueba="desglose-diferido-declarado">
          −{formatearImporte(tarjeta.importeDiferidoDeclarado, iso)}
        </b>
      </div>
      <div className="fila">
        <span className="crece">Compras a meses con plan registrado</span>
        <b data-prueba="desglose-diferido-por-planes">
          −{formatearImporte(tarjeta.importeDiferidoPorPlanes, iso)}
        </b>
      </div>
      <div className="fila">
        <span className="crece">
          <b>{enPasado ? 'Se esperaba pagar este periodo' : 'Se espera pagar este periodo'}</b>
        </span>
        <b data-prueba="desglose-pago-esperado">
          {formatearImporte(tarjeta.importePagoEsperado, iso)}
        </b>
      </div>

      {/* Texto ARMADO POR EL SERVIDOR (RNF-130): la pantalla no lo compone. */}
      <span className="ayuda" data-prueba="texto-del-pago-esperado">
        {tarjeta.textoDesgloseDePagoEsperado}
      </span>
    </div>
  );
}
